<template>
  <div class="home">
    <InventoryTransferList v-show="listView" @newInventory="onClickNewFromList" @editInventory="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <InventoryTransferForm v-show="formView" :inventory="inventory" @backClicked="onBackChild"/>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import InventoryTransferList from '@/components/inventory/InventoryTransferList.vue'
import InventoryTransferForm from '@/components/inventory/InventoryTransferForm.vue'

export default {
  name: 'InventoryTransfer',
  components: {
    InventoryTransferForm,
    InventoryTransferList
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      inventory: {
        id: null,
        transfer_no: null,
        transfer_date: null,
        warehouse_origin: null,
        warehouse_to: null,
        branch_no: null,
        company_to: null,
        company_origin: null,
        notes: null,
        details: [{
          id: null,
          transfer_no: null,
          product_no: null,
          product: [{
            product_no: null,
            product_name: null
          }],
          qty: null,
          uom_id: null,
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }],
          transfer_date: null,
          type: null,
          warehouse_no: null,
          warehouse: null,
          branch_no: null,
          branch: null,
          company_no: null,
          amount: '0',
          serial_number: null,
          disableSN: false
        }]
      }
    }
  },
  computed: {
    ...mapState({
      uomList: state => state.uom.uomList
    })
  },
  mounted () {
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getUomList')
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getCompanyList')
    var payload = {
      status: 'order'
    }
    this.$store.dispatch('getProductListSelect', payload)
  },
  methods: {
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.inventory = {
        id: null,
        transfer_no: null,
        transfer_date: new Date().toISOString(),
        warehouse_origin: null,
        warehouse_to: null,
        branch_no: null,
        company_to: null,
        company_origin: null,
        notes: null,
        details: [{
          id: null,
          transfer_no: null,
          product_no: null,
          product: [{
            product_no: null,
            product_name: null
          }],
          qty: null,
          uom_id: null,
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }],
          transfer_date: null,
          type: null,
          warehouse_no: null,
          warehouse: null,
          branch_no: null,
          branch: null,
          company_no: null,
          amount: '0',
          serial_number: null,
          detailSN: false
        }]
      }
    },
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.inventory = value
      this.listView = false
      this.formView = true
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
    }
  }
}
</script>
